/*
 *验证码登录
*/
import React from 'react'
import './login.less'
import api from '../../api/api.js'
import { Form, Input, Button,Select, message } from 'antd'
import {API_CONFIG} from '../../api/config.js'
import qw from '../../static/img/qw.png'
const {Option}=Select;

class Yzmdl extends React.Component {
    state = {
        isFocus: false,
        t60: 60,
        login_loading: false,
        getcode_loding: false,
    }
    componentDidMount(){

        // 如果已经输入过正确的手机号码，则自动填充
        const phoneRegular=/^1[3456789]\d{9}$/;
        const username=sessionStorage.getItem('username')
        if( phoneRegular.test(username) ){
            this.props.form.setFieldsValue( { phone: username})
        }
    }
    handleSubmit = e => {
    
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            this.setState({
                login_loading: true
            })
            if (!err) {
                    api.check_has_group({
                        mobile: values.phone,
                        sms_code: values.captcha,
                    }).then(res=>{
                        if(res.code === 0){
                            clearInterval(this.timer)
                            this.setState({ 
                                 t60: 60,
                                 login_loading: false
                            })
                            sessionStorage.setItem('source',res.content.source);
                            document.cookie= `${API_CONFIG.company_token}=${res.content.access_token};domain=colourlife.com;;path=/;`
                            sessionStorage.setItem('access_token', res.content.access_token);
                            sessionStorage.setItem('userInfo',
                            JSON.stringify({
                                mobile: values.phone,
                                sms_code:  values.captcha,
                            }))
                            if(res.content.register === 1){
                                //已注册
                                if (res.content.has_team === 2) { //无团队登录成功
                                    message.error('您还没有创建企业，请先去注册')
                                } else if(res.content.has_team === 1 && res.content.team.length === 1) {
                                    sessionStorage.setItem('team', JSON.stringify(res.content.team))
                                    //登录指定团队后台
                                    api.get_company_login({
                                        access_token: sessionStorage.getItem('access_token'),
                                        corp_uuid: res.content.team[0].id,
                                        source:sessionStorage.getItem('source')
                                    }).then(res=>{
                                        this.setState({grounpLoading: false})
                                        if(res.code===0) {
                                            sessionStorage.setItem('company_token',res.content.access_token)
                                            document.cookie= `${API_CONFIG.cloud_token}=${res.content.access_token};domain=colourlife.com;;path=/;`
                                            if(sessionStorage.getItem('market_url')){
                                                let market_url = sessionStorage.getItem('market_url')
                                                window.location.href=`${market_url}`
                                            } else {
                                                window.location.href=`${API_CONFIG.yun_base}`
                                            }
                                        }
                                    })
                                }else if (res.content.has_team === 1 && res.content.team.length > 1) {
                                    //有团队
                                    sessionStorage.setItem('team',JSON.stringify(res.content.team));
                                    this.props.onSucessLogin(true, res.content.team )
                                }
                            }else{
                                //未注册
                                message.error('没有此账号，请先去注册')
                            }
                        } else {
                            this.setState({ login_loading: false })
                        }
                    }).catch(err =>{
                        this.setState({ login_loading: false })
                    })
            }
        });
    };

    validateMobile() {
        const { getFieldValue } = this.props.form;
        if(!getFieldValue('phone')) {
            message.error('请输入您的手机号')
            return;
        } else{
            let pattern = /^1[3456789]\d{9}$/
            if(!pattern.test(getFieldValue('phone'))){
                message.error('手机号填写不正确')
                return
            }
            if(this.state.t60 !== 60) return;
            this.getCode()
        }    
    }
  
     // 注册发送验证码
     getCode = () => {
        var that = this;
        this.setState({getcode_loding:true, t60: 59});
        api.sms_send_code({
            mobile: this.props.form.getFieldValue('phone'),
            type: 1
        }).then(res => {
            this.setState({getcode_loding:false});
            if (res.code === 0) {
                message.success(res.content.notice);
                let tt = that.state.t60;
                this.timer = setInterval(() => {
                    tt--;
                    if (tt === 0) {
                        clearInterval(this.timer)
                        that.setState({ t60: 60 })
                    } else {
                        that.setState({ t60: tt });
                    }
                }, 1000)
            } else {
                message.error( 'code:' + res.code);
                clearInterval(this.timer)
            }
        }).catch(err => {
            message.error( 'err:' + err);
            clearInterval(this.timer)
            this.setState({getcode_loding:false});
        })
    }

    // 跳转到企业微信
    goQW = () =>{

        let url = encodeURIComponent(`${API_CONFIG.base}/web/#/login`);
        window.location.href = `${API_CONFIG.weixinBase}/oauth/sso/authorizer?turn_url=${url}`;
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { isfocus,  login_loading,getcode_loding } = this.state
        const prefixSelector = getFieldDecorator('prefix', {
            initialValue: '86',
        })(
            <Select style={{ width: 70 }}>
                <Option value="86">+86</Option>
                <Option value="87">+87</Option>
                <Option value="60">+60</Option>
                <Option value="91">+91</Option>
                <Option value="1">+1</Option>
                <Option value="32">+32</Option>
            </Select>,
        );
        return (
            <Form style={{paddingTop: 0}}>
                <Form.Item  className={ isfocus ? 'special-item phone-item'  : 'special-item' } >
                    {getFieldDecorator('phone', {
                        rules: [
                            { required: true, message: '请输入您的手机号',  pattern: /^1[3456789]\d{9}$/, },
                        ],
                    })(<Input 
                        placeholder='请输入您的手机号' 
                        autoComplete="off"
                        onFocus={() => {
                            this.setState({
                                isfocus: true
                            })
                        }} 
                        onBlur={() => {
                            this.setState({
                                isfocus: false
                            })
                        }} 
                        />)}
                          <span  className='label'  > 手机： </span>
                         <span  ><img src={require("./../../imgs/mobile.png")} alt=""/></span>
                </Form.Item>  
                <Form.Item 
                    className='item code-item'>
                   {getFieldDecorator('captcha', {
                       rules: [{ required: true, message: '请输入您的验证码' }],
                   })(<Input placeholder='请输入您的验证码'  autoComplete="off"/>)}

                   <span  className='label'  > 验证码： </span>
                   <span 
                       className='code-text' 
                       onClick={() => {this.validateMobile()}} 
                       style={this.state.t60 === 60   ? {cursor:'pointer'} : {color:'#bfbfbf'}}
                   >  {this.state.t60 === 60 ?  "点击发送验证码" : (this.state.t60 + '秒后重新获取')}
                   </span>
                   
               </Form.Item> 
                <Button  className='register-btn' onClick={this.handleSubmit} loading={login_loading}>登录</Button>
                <Button 
                    className='qw-registre-btn' 
                    onClick={this.goQW} 
                >
                    <img src={qw}/>
                    企业微信登录
                </Button>
                {/*<span 
                        className='register-type' 
                        style={{cursor:'pointer'}}
                        onClick={() => {
                            this.props.history.push('/register')
                        }}
                    >新用户免费注册</span>*/}
                <span 
                        className='yzmlogin-type' 
                        onClick={() => {
                            this.props.setLogintype(false)
                        }}
                    >密码登录</span>
            </Form>
       )
    }
}
const WrappedNormalLoginForm = Form.create({  })(Yzmdl);
export default WrappedNormalLoginForm;


// WEBPACK FOOTER //
// ./src/pages/login/yzmdl.jsx